module.exports = __webpack_public_path__ + "img/sandwitch.9304f824.svg";